import { z } from 'zod';

export enum ModMailType {
  Feedback = 'feedback',
}

export const CreateModMailSchema = z.object({
  type: z.nativeEnum(ModMailType),
  title: z.string().max(200).optional(),
  content: z.string().min(1, { message: 'Content is required' }).max(5000),
  contactInfo: z.string().max(200).optional(),
  userId: z.string().uuid().optional(),
});

export type CreateModMailDto = z.infer<typeof CreateModMailSchema>;
